import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import useBudgetIncomeChart from "./useBudgetIncomeChart";
import { FormSectionHeader, Loader } from "@/components";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top" as const,
      labels: {
        usePointStyle: true,
        pointStyle: "circle", // <-- Makes legend marker round
      },
    },
  },
};

const BudgetIncomeChart = () => {
  const { isChartDataLoading, chartData, currentFinanceYear } = useBudgetIncomeChart();

  return (
    <div className="bg-white rounded-lg p-[20px]">
      <FormSectionHeader>
        Budget Income vs Actual Income(Year: {currentFinanceYear})
      </FormSectionHeader>
      {isChartDataLoading ? (
        <Loader />
      ) : (
        <Bar options={options} data={chartData} />
      )}
    </div>
  );
};

export default BudgetIncomeChart;
